module.exports = __webpack_public_path__ + "static/media/UsersStats.216d425f.svg";